/**
 * Les appels des lettres de voiture (eCMR) — lot 161, 04/11/2026.
 * Routes : `apps/api/src/lettres_voiture.ts`.
 */

import { appeler, echec, type Resultat } from './api.js';
import type { EtatDesLettres } from './lettreVoiture.js';

export async function lireLesLettres(jeton: string, otId: string): Promise<Resultat<EtatDesLettres>> {
  const e = await appeler(`/ordres-transport/${otId}/lettres-voiture`, jeton);
  if (e.etat !== 'succes') return echec(e);
  return { etat: 'ok', valeur: e.corps as EtatDesLettres };
}

export async function genererLesLettres(jeton: string, otId: string): Promise<Resultat<EtatDesLettres>> {
  const e = await appeler(`/ordres-transport/${otId}/lettres-voiture`, jeton, { methode: 'POST' });
  if (e.etat !== 'succes') return echec(e);
  return { etat: 'ok', valeur: e.corps as EtatDesLettres };
}

export async function refaireLaLettre(
  jeton: string,
  otId: string,
  lettreId: string,
): Promise<Resultat<EtatDesLettres>> {
  const e = await appeler(`/ordres-transport/${otId}/lettres-voiture/${lettreId}/refaire`, jeton, {
    methode: 'POST',
  });
  if (e.etat !== 'succes') return echec(e);
  return { etat: 'ok', valeur: e.corps as EtatDesLettres };
}
